import { Center, Container, Stack, Text, Title } from '@mantine/core';
import * as icons from '@sloyd/icons';
import Button from '../Button/Button';
import styles from './ComingSoon.module.css';

export type ComingSoonProps = {};

export function ComingSoon(_props: ComingSoonProps) {
  return (
    <div className={styles.wrapper} data-testid='ComingSoon-wrapper'>
      <Container size='lg' className={styles.content}>
        <Center>
          <icons.IconClock size={50} className={styles.icon} stroke={0.5} />
        </Center>
        <Title className={styles.title}>Coming Soon</Title>
        <Text size='md' className={styles.subtitle}>
          We are working hard to bring something amazing to you.
          <br />
          Stay tuned!
        </Text>
        <Stack align='center' className={styles.buttonContainer}>
          <Button variant='filled' color='blue' size='md'>
            Notify Me
          </Button>
        </Stack>
      </Container>
    </div>
  );
}

export default ComingSoon;
